import { styled } from "@mui/material/styles";
import { useEffect } from "react";
import * as React from "react";

const MainContent = styled("main")(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100vw",
  minHeight: "100vh",
  backgroundColor: theme.palette.background.default,
  padding: 0,
  margin: 0,
}));

export interface PageProps {
  title: string;
  children: React.ReactNode;
}

export const Page: React.FC<PageProps> = ({ title, children }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return <MainContent>{children}</MainContent>;
};
